module.exports = "/virtual-football-league/img/amblems/left/logos/Lyon.png";


//////////////////
// WEBPACK FOOTER
// ./src/games/virtual-football-league/img/amblems/left/logos/Lyon.png
// module id = 2108
// module chunks = 4